export const slugifyOptions = {
  replacement: '-',
  remove: /[$*_+~.#()''!\-:@\?]/g,
  lower: true
}

export const timeApiUrl = 'https://www.hive.fi/.netlify/functions/time'
export const launchTimestamp = 1562569200000

export const homePageId = 'c5T7roBiI1O2is82EiIkK8o'

// Pages that are not in Contentful
export const additionalPages = {
  '/en/news': {
    id: 'news', 
    title: 'News',
    path: '/en/news'
  },

  '/fi/uutiset': {
    id: 'news___fi-FI', 
    title: 'Uutiset',
    path: '/fi/uutiset'
  },

  '/en/search': {
    id: 'search', 
    title: 'Search',
    path: '/en/search'
  },
  
  '/fi/search': {
    id: 'search___fi-FI', 
    title: 'Haku',
    path: '/fi/search'
  }
}


// WEBPACK FOOTER //
// ./src/config.js